<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="3" md="3" xl="3">
        <DatePicker locale="vi" mode="range" v-model="dateRange" class="datepicker" :input-props="{readonly: true}"/>
      </CCol>
      <CCol sm="3" md="4" xl="3">
        <BaseSelect
          :options="userNameSelect.options"
          :data="userNameSelect.data"
          ref="userNameSelect"
        >
        </BaseSelect>
      </CCol>
    </CRow>

    <CCard class="mt-3p5 content-fade-in">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #createdDate="{item}">
            <td>
              {{ formatDate(item.createdDate) }}
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseTable from "../base/BaseDataTable";

export default {
  name: "AccessPage",
  components: {
    BaseTable,
    BaseSelect,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      dateRange: {
        start: new Date(),
        end: new Date()
      },
      userNameSelect: {
        options: {
          selectAllText: "Tất cả user"
        },
        data: {
          model: "",
          source: {
            url: "/user/getListUserActive",
            response: function(dataResponse) {
              return dataResponse.data;
            }
          },
          updateTrigger: function() {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            { key: "username", label: "Tên đăng nhập" },
            { key: "createdDate", label: "Ngày" },
            { key: "os", label: "OS" },
            { key: "ipAddress", label: "Địa chỉ IP" },
            { key: "urlRequest", label: "Url" },
            { key: "nameController", label: "Tên Controller" },
            { key: "nameMethod", label: "Tên Method" }
          ],
          slots: ["createdDate"],
        },
        dataSource: {
          url: "/log/pageAccessLog",
          dataSubmit: function() {
            var userNameSelected = that.userNameSelect.data.model;
            return {
              fromDate: that.$helper.formatDateDDMMYYYY(that.dateRange.start.getTime()),
              toDate:  that.$helper.formatDateDDMMYYYY(that.dateRange.end.getTime()),
              userName: userNameSelected === "0" ? "" : userNameSelected
            };
          },
          response: function(dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    formatDate: function(val) {
      return this.$helper.formatDate(val);
    },
    loadDataMainTable: function() {
      this.$refs.mainTable.loadData();
    }
  },
  created: function() {
    if (!this.$helper.checkLogin()) {
      this.$router.push("/");
    }
  },
  mounted() {},
  watch: {
    dateRange: function(newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date(),
          end: new Date()
        }
      }
    }
  }
};
</script>
